import { useDispatch } from 'react-redux';

import { deriveProductCategory } from '~/shared/utils/deriveProductCategory';
import { Gender } from '~/techstyle-shared/react-accounts';
import { useProductDetailContext } from '~/techstyle-shared/react-components';

import { trackSpeedySignupPageView } from '../actions';

export const useTrackSpeedySignupPageView = () => {
  const dispatch = useDispatch();

  const { product, bundleProducts, isBundle } = useProductDetailContext();
  const { isMens } = deriveProductCategory(
    isBundle ? bundleProducts[0] : product
  );
  const productGender = isMens ? Gender.MALE : Gender.FEMALE;

  return () => {
    dispatch(
      trackSpeedySignupPageView({
        pageName: `/speedy-signup/${productGender}/registration-start`,
      })
    );
  };
};
